import { getActiveMembersByTrialHospitalUidsHandler } from '../getActiveTrialMembersByTrialHospitalUids/mock'
import { getTrialMembersHandler } from '../getTrialMembers/mock'

export const memberHandlers = [
  getTrialMembersHandler(),
  getActiveMembersByTrialHospitalUidsHandler(),
]
